import { render, staticRenderFns } from "./TimeOffPolicies.vue?vue&type=template&id=5d5fbbdd&"
import script from "./TimeOffPolicies.vue?vue&type=script&lang=js&"
export * from "./TimeOffPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports